import type { ReactNode } from 'react';
import './EmptyState.css';

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="nx-empty-state" role="status">
      {icon && <div className="nx-empty-state__icon">{icon}</div>}
      <div className="nx-empty-state__title">{title}</div>
      {description && <div className="nx-empty-state__description">{description}</div>}
      {action && <div className="nx-empty-state__action">{action}</div>}
    </div>
  );
}